import { cn } from '../../lib/utils';

import { FunnelIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';

interface PlanverseSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  onFilter?: () => void;
  placeholder?: string;
  className?: string;
}

export default function PlanverseSearchBar({
  value,
  onChange,
  onFilter,
  placeholder = 'Search for Project',
  className,
}: PlanverseSearchBarProps) {
  return (
    <div
      className={cn(
        'flex h-11 w-full max-w-md items-center gap-1.5 rounded-full border border-border bg-background px-4 font-display',
        className,
      )}
    >
      <MagnifyingGlassIcon className="h-5 w-5 flex-shrink-0 text-muted-foreground" />
      <input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label="Search Planverse"
        className="flex-1 border-0 bg-transparent text-base text-foreground placeholder:text-muted-foreground/70 focus:outline-none"
      />
      <button
        type="button"
        onClick={onFilter}
        aria-label="Filter results"
        className="flex-shrink-0 text-muted-foreground transition-colors hover:text-foreground"
      >
        <FunnelIcon className="h-5 w-5" />
      </button>
    </div>
  );
}
